var _rect, _rect2, _path, _path2, _path3, _circle, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle3, _circle4, _circle5, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 241,
    viewBox: "0 0 364 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.8984,
    y: 67.002,
    width: 296.623,
    height: 158.725,
    rx: 19.6928,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.57812,
    y: 148.223,
    width: 353.24,
    height: 102.448,
    rx: 19.6928,
    fill: "#29315D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.578 186.221C117.578 181.546 121.368 177.756 126.043 177.756L283.234 177.756C287.909 177.756 291.699 181.546 291.699 186.221C291.699 190.896 287.909 194.685 283.234 194.685H126.043C121.368 194.685 117.578 190.896 117.578 186.221Z",
    fill: "#434A70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.578 213.219C117.578 208.544 121.368 204.754 126.043 204.754L191.466 204.754C196.141 204.754 199.931 208.544 199.931 213.219C199.931 217.894 196.141 221.683 191.466 221.683H126.043C121.368 221.683 117.578 217.894 117.578 213.219Z",
    fill: "#434A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.727 213.218C210.727 208.543 214.516 204.754 219.191 204.754L228.587 204.754C233.261 204.754 237.051 208.543 237.051 213.218C237.051 217.893 233.261 221.682 228.587 221.682H219.191C214.516 221.682 210.727 217.893 210.727 213.218Z",
    fill: "#434A70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6174,
    cy: 199.705,
    r: 31.7893,
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8394 193.742L60.993 204.589L54.4844 198.08",
    stroke: "white",
    strokeWidth: 5.96048,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.004,
    cy: 64.7896,
    r: 49.481,
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.215 71.2305C196.215 65.0278 191.186 59.9995 184.984 59.9995C191.186 59.9995 196.215 54.9712 196.215 48.7686C196.215 54.9712 201.243 59.9995 207.446 59.9995C201.243 59.9995 196.215 65.0278 196.215 71.2305Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.21 71.23V73.4762",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.21 48.7696V46.5234",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.411 44.2783C168.411 49.2405 164.388 53.2631 159.426 53.2631C164.388 53.2631 168.411 57.2857 168.411 62.2479C168.411 57.2857 172.434 53.2631 177.396 53.2631C172.434 53.2631 168.411 49.2405 168.411 44.2783Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.425 62.2495V64.4957",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M168.425 42.0332V44.2794",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M177.406 86.9731V89.2193",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.406 71.2486V69.0024",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.41 70.125C177.41 75.0872 173.387 79.1098 168.425 79.1098C173.387 79.1098 177.41 83.1324 177.41 88.0945C177.41 83.1324 181.432 79.1098 186.394 79.1098C181.432 79.1098 177.41 75.0872 177.41 70.125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.49052,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.869,
    cy: 87.9667,
    r: 6.19714,
    fill: "#EAEAEF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.1788,
    cy: 87.9667,
    r: 6.19714,
    fill: "#EAEAEF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.4886,
    cy: 87.9667,
    r: 6.19714,
    fill: "#EAEAEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 280.797,
    y: 81.7695,
    width: 34.7042,
    height: 13.6338,
    rx: 4.95775,
    fill: "#EAEAEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.1caef63bd437fc38a54088c7f2c19b2d.svg";
export { ForwardRef as ReactComponent };